import { useNavigate } from "react-router-dom";
import CompanySelector from "../../../components/common/CompanySelector";

export default function EmployeeManagementHeader({
  companyList,
  selectedCompany,
  setSelectedCompany,
  selectedFilter,
  setSelectedFilter,
}) {
  const navigate = useNavigate();

  const handleAddEmployeeClick = () => {
    navigate("/addemployee");
  };

  return (
    <div className="flex items-center justify-between mt-7 mb-6">
      <h1 className="text-2xl font-medium text-medium-dark-gray">
        Employee Management
      </h1>

      <div className="flex items-center gap-8">
        <CompanySelector
          companyList={companyList}
          selectedCompany={selectedCompany}
          onCompanyChange={(company) => {
            if (!company) {
              setSelectedCompany(null);
              return;
            }

            setSelectedCompany({
              id: company.id,
              name: company.company_name,
            });
          }}
          selectClassName="!py-0.5 px-2 text-sm w-[200px]"
        />
        <div className="flex justify-center items-center px-[10px]  border border-[#cacaca] text-[var(--secondary-color)] rounded text-[12px]">
          <i className="ri-filter-2-fill"></i>
          <select
            name="filter"
            id="filter"
            className="!py-3 px-2 border-none text-[var(--secondary-color)] text-sm bg-[var(--primary-color)] w-[140px] outline-none"
            onChange={(e) => setSelectedFilter(e.target.value)}
            value={selectedFilter}
          >
            <option value="">Filter</option>
            <option value="Active">Active</option>
            <option value="In Active">In Active</option>
            <option value="Sort By Name">By Name</option>
            <option value="Sort By Employee ID">By Employee ID</option>
          </select>
        </div>
        <div>
          <button
            className="flex items-center justify-center gap-2.5 h-10 bg-primary-hrms text-white rounded-lg text-sm w-40 "
            onClick={handleAddEmployeeClick}
          >
            <span>
              <i className="ri-add-line"></i>
            </span>
            Add Employee
          </button>
        </div>
      </div>
    </div>
  );
}
